if (!customElements.get('look-component')) {
  customElements.define(
    'look-component',
    class LookComponent extends HTMLElement {
      constructor() {
        super();

        this.flkty = null;
        this.observer = null;

        this.checkSlidesSizeOnResize = () => this.checkSlidesSize();
        this.resizeSliderEvent = (event) => this.resizeSlider(event);
        this.pointersInit = (event) => this.dotPointers(event);
        this.pointersOver = (event) => this.dotPointerIn(event);
        this.pointersOut = (event) => this.dotPointerOut(event);

        this.buyAllEvent = () => this.buyAll();
        this.onBuyAllSubmit = (event) => this.handleBuyAllSubmit(event);
        this.onBuyAllPopupClosed = () => this.handleBuyAllPopupClosed();
      }

      connectedCallback() {
        this.slider = this.querySelector('[data-slider]');
        this.productOnRow = Number(this.slider?.getAttribute('data-products')) || 3;
        this.slides = this.querySelectorAll('[data-slide-item]');
        this.sTLHotspotsItems = this.querySelectorAll('[data-stl-hotspots-item]');
        this.pointers = this.querySelectorAll('[data-pointer]');
        this.pointerBubbles = this.querySelectorAll('[data-pointer-bubble]');
        this.buttonsQuickView = this.querySelectorAll('[data-button-quick-view]');
        this.shopTheLookQuickViewButton = this.querySelectorAll('[data-shop-the-look-quick-view-button]');

        this.shopTheLookQuickViewButton?.forEach((button) => {
          button.addEventListener('click', () => {
            const firstHotspotButton = [...this.buttonsQuickView].find((btn) => btn.hasAttribute('data-shop-the-look-quick-view'));
            firstHotspotButton?.dispatchEvent(new Event('click'));
          });
        });

        this.buyAllButton = this.querySelector('[data-buy-all-button]');
        this.buyAllError = this.querySelector('[data-buy-all-error]');
        this.buyAllButton?.addEventListener('click', this.buyAllEvent);

        this.listen();
      }

      listen() {
        if (this.slider) {
          this.checkSlidesSize();
          document.addEventListener('theme:resize:width', this.checkSlidesSizeOnResize);
          this.slider.addEventListener('theme:slider:resize', this.resizeSliderEvent);
        }

        this.pointers.forEach((pointer) => {
          pointer.addEventListener('click', this.pointersInit);
          pointer.addEventListener('mouseover', this.pointersOver);
          pointer.addEventListener('mouseleave', this.pointersOut);
        });

        this.pointerBubbles.forEach((pointerBubble, index) => {
          pointerBubble.addEventListener('click', (event) => [...this.pointers][index].dispatchEvent(new Event(event.type)));
          pointerBubble.addEventListener('mouseover', (event) => [...this.pointers][index].dispatchEvent(new Event(event.type)));
          pointerBubble.addEventListener('mouseleave', (event) => [...this.pointers][index].dispatchEvent(new Event(event.type)));
        });
      }

      checkSlidesSize() {
        const isMobile = window.innerWidth < theme.sizes.small;
        const isDesktop = window.innerWidth >= theme.sizes.large;
        const isTablet = window.innerWidth >= theme.sizes.small && window.innerWidth < theme.sizes.large;
        const shouldInitOnDesktop = Boolean(isDesktop && this.slides.length > this.productOnRow);
        const shouldInitOnTablet = Boolean(isTablet && this.slides.length > 2);

        if (!isMobile) {
          if (shouldInitOnDesktop || shouldInitOnTablet) {
            this.initSlider();
          } else {
            this.destroySlider();
            this.slidesTabIndex();
          }

          return;
        }

        this.destroySlider();
      }

      initSlider() {
        if (this.flkty === null) {
          this.flkty = new window.theme.Flickity(this.slider, {
            prevNextButtons: true,
            wrapAround: true,
            adaptiveHeight: false,
            cellAlign: 'left',
            groupCells: false,
            contain: true,
            on: {
              ready: () => {
                this.slidesTabIndex();
                this.setSliderArrowsPosition();
                this.dotPointers();
                requestAnimationFrame(() => {
                  if (this.flkty) {
                    this.flkty.resize();
                  }
                });
              },
              change: () => {
                this.slidesTabIndex();
                this.dotPointers();
              },
            },
          });

          return;
        }

        this.setSliderArrowsPosition();
      }

      setSliderArrowsPosition() {
        const isDesktop = window.innerWidth >= theme.sizes.small;

        if (!isDesktop) return;

        const arrows = this.slider.querySelectorAll('.flickity-button');
        const image = this.slider.querySelector('[data-product-media-container]');

        if (arrows.length && image) {
          arrows.forEach((arrow) => {
            arrow.style.top = `${image.offsetHeight / 2}px`;
          });
        }
      }

      slidesTabIndex() {
        if (this.slides.length < this.productOnRow + 1) {
          this.slider.querySelectorAll('a, button').forEach((link) => {
            link.setAttribute('tabindex', '0');
          });

          return;
        }

        const slider = window.theme.Flickity.data(this.slider);

        slider.cells.forEach((slide) => {
          let tabIndex = '-1';
          if (slide.element.classList.contains('is-selected')) {
            tabIndex = '0';
          }

          slide.element.querySelectorAll('a, button').forEach((link) => {
            link.setAttribute('tabindex', tabIndex);
          });
        });
      }

      destroySlider() {
        if (typeof this.flkty === 'object' && this.flkty !== null) {
          this.flkty.destroy();
          this.flkty = null;
        }
      }

      resizeSlider(event) {
        const slider = event.target;
        const flkty = window.theme.Flickity.data(slider) || null;

        if (!flkty) return;
        flkty.resize();
      }

      dotPointers(event) {
        if (this.pointers.length === 0) return;

        this.sTLHotspotsItems.forEach((element) => element.classList.remove('on-hover'));

        if (event) {
          const dotIndex = event.target.getAttribute('data-pointer');

          this.flkty?.select(dotIndex);

          return;
        }

        const slideIndex = this.flkty == null ? 0 : this.flkty.selectedIndex;

        if (slideIndex >= 0) {
          this.sTLHotspotsItems[slideIndex].classList.add('on-hover');
        }
      }

      dotPointerIn(event) {
        const dotIndex = event.target.getAttribute('data-pointer');
        const image = this.slides[dotIndex].querySelector('[data-product-media-container]');
        const isTouch = matchMedia('(pointer:coarse)').matches;
        const isMobile = window.innerWidth < theme.sizes.small;
        if (!isMobile && !isTouch) {
          this.observeImage(image);
        }

        this.pointers[dotIndex].style.setProperty('--target-animation', 'none');
      }

      dotPointerOut(event) {
        const dotIndex = event.target.getAttribute('data-pointer');
        const image = this.slides[dotIndex].querySelector('[data-product-media-container]');
        image.classList.remove('product-grid-item__image--hovered');
        image.dispatchEvent(new Event('mouseleave'));
        if (this.observer) {
          this.observer.disconnect();
        }

        this.pointers.forEach((pointer) => {
          pointer.style.removeProperty('--target-animation');
        });
      }

      observeImage(image) {
        this.observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              const target = entry.target;
              const outsideWrapper = entry.intersectionRatio == 0;

              if (!outsideWrapper) {
                target.dispatchEvent(new Event('mouseenter'));
                target.classList.add('product-grid-item__image--hovered');
              }
            });
          },
          {
            root: this.slider,
            threshold: [0.95, 1],
          }
        );
        this.observer.observe(image);
      }

      buyAll() {
        if (this.buyAllData) return;

        this.buyAllData = new FormData();
        this.buyAllIndex = 0;

        this.querySelectorAll('[data-buy-all-variant-id]').forEach((element) => {
          this.buyAllAppend('id', element.getAttribute('data-buy-all-variant-id'));
          this.buyAllIndex++;
        });

        this.buyAllQueue = [...this.querySelectorAll('[data-buy-all-quick-view]')];

        this.buyAllButton.setAttribute('disabled', '');
        document.body.classList.add('js-buy-all-active');
        document.addEventListener('submit', this.onBuyAllSubmit, true);
        document.addEventListener('theme:quickview:closed', this.onBuyAllPopupClosed);

        this.buyAllError.hidden = true;

        this.buyAllNext();
      }

      buyAllAppend(key, value) {
        this.buyAllData.append(key.replace(/^(\w+)/, `items[${this.buyAllIndex}][$1]`), value);
      }

      buyAllNext() {
        if (!this.buyAllData) return;

        const nextButton = this.buyAllQueue.shift();

        if (!nextButton) {
          this.buyAllSubmit();
          return;
        }

        this.buyAllPicked = false;
        nextButton.click();
      }

      handleBuyAllSubmit(event) {
        const popup = event.target.closest('.popup-quick-view');
        if (!popup || event.target.closest('[data-form-wrapper]')?.classList.contains('variant--soldout')) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        new FormData(event.target).forEach((value, key) => {
          if (/^(id|quantity|selling_plan|properties\[.+\])$/.test(key) && value !== '') this.buyAllAppend(key, value);
        });

        this.buyAllIndex++;
        this.buyAllPicked = true;
        popup.classList.add('popup-quick-view--animate-out');
      }

      handleBuyAllPopupClosed() {
        if (!this.buyAllData) return;

        if (!this.buyAllPicked) {
          this.buyAllReset();
          return;
        }

        // Quick views share one popup that PhotoSwipe resets when it finishes closing, so wait for that first
        const popup = document.querySelector('.pswp');
        const waitForPopupToClose = () => {
          if (popup.classList.contains('pswp--open')) {
            requestAnimationFrame(waitForPopupToClose);
            return;
          }

          this.buyAllNext();
        };

        waitForPopupToClose();
      }

      buyAllSubmit() {
        fetch(theme.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/javascript',
          },
          body: this.buyAllData,
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.buyAllError.textContent = response.description || response.message;
              this.buyAllError.hidden = false;
              return;
            }

            const cartElement = document.querySelector('cart-items');

            if (window.theme.settings.cartType === 'drawer' && cartElement?.hasAttribute('data-cart-drawer')) {
              document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
            } else {
              window.location = theme.routes.cart_url;
            }
          })
          .catch((error) => console.error(error))
          .finally(() => this.buyAllReset());
      }

      buyAllReset() {
        this.buyAllData = null;
        this.buyAllQueue = [];
        this.buyAllButton?.removeAttribute('disabled');
        this.buyAllButton?.focus();
        document.body.classList.remove('js-buy-all-active');
        document.removeEventListener('submit', this.onBuyAllSubmit, true);
        document.removeEventListener('theme:quickview:closed', this.onBuyAllPopupClosed);
      }

      disconnectedCallback() {
        if (this.buyAllData) this.buyAllReset();
        document.removeEventListener('theme:resize:width', this.checkSlidesSizeOnResize);

        if (this.slider) {
          this.slider.removeEventListener('theme:slider:resize', this.resizeSliderEvent);
        }
      }
    }
  );
}
